import classnames from "classnames";
import { extendTailwindMerge } from "tailwind-merge";

// 从themes.json中提取的所有字体样式类名
const fontStyleClasses = [
  // Display classes
  "display_m", "display_s", "display_xs",
  // Headline classes
  "headline_regular_xl", "headline_regular_l", "headline_regular_m", "headline_regular_s",
  // Title classes
  "title_xxl", "title_xl", "title_l", "title_m", "title_s",
  // Button classes
  "button_l", "button_m", "button_s",
  // Body medium classes
  "body_medium_xl", "body_medium_l", "body_medium_m", "body_medium_s", "body_medium_xs", "body_medium_xxs",
  // Body regular classes
  "body_xl", "body_l", "body_m", "body_s", "body_xs", "body_output", "body_output_m",
  // Body bold classes
  "body_bold_l", "body_bold_m", "body_bold_s", "body_bold_xs", "body_bold_xl",
];

const buttonStyleClasses = [
  "emphasis_button", "tonal_button", "primary_button", "link_button", "secondary_button",
]

const buttonSizeClasses = [
  "md_button", "sm_button", "xs_button", "lg_button",
]

// 扩展tailwind-merge配置，添加自定义字体样式类组
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // 将字体样式类添加到font-family组中，这样它们会互相冲突
      "font-family": [
        ...fontStyleClasses,
      ],
      // 将button风格类添加到button-style组中，这样它们会互相冲突
      "button-style": [
        ...buttonStyleClasses,
      ],
      // 将button尺寸类添加到button-size组中，这样它们会互相冲突
      "button-size": [
        ...buttonSizeClasses,
      ],
    } as any, // 使用类型断言以支持自定义类组
  },
});

export const cn = (...args: classnames.ArgumentArray) => {
  return customTwMerge(classnames(...args));
};
